import { createContext, useContext } from "react";
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { AddEquity } from "../../../../components/CompanyComponent";
import { AlertV2 } from "../../../../components/Alert";
import { getEquityInvestmentList } from "../../../../apis/Business/EquityInvestmentApi";
import { NonCompanyComponent } from "../../../../components/ProductComponent";
import { YearTabContext } from "../../../../components/Skeleton";
import { useTranslation } from "react-i18next";
import { useUserAccess } from "../../../../components/WriteAccessContext";

export const Header = () => {
  const { t } = useTranslation();
  return (
    <div className="companydetail__group table__equity table__header">
      <div className="companydetail__row" style={{ backgroundImage: "none" }}>
        <div
          className="modaladdlocation__question"
          style={{ backgroundImage: "none", backgroundColor: "transparent" }}
        >
          <h6>{t("INVESTMENT_TYPE")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("INVESTEE_NAME")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("TOTAL_INVESTEE_REVENUE")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("CARBON_EMISSIONS_INVESTMENT")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("%_INVESTMENT")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("YOUR_SHARE")}</h6>
        </div>
      </div>
    </div>
  );
};

export const ApiVarEquityInvestmentContext = createContext();

const EquityInvestments = () => {
  const yearTab = useContext(YearTabContext);
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const apiVariable = [
    "invesment_type",
    "investee_name",
    "total_investee_revenue",
    "carbon",
    "equity",
    "your_share",
  ];
  let { businessId } = useParams();

  const [supplies, setSupplies] = useState([]);

  const [saveSpecial, setSaveSpecial] = useState(false);
  const [saveAllAlert, setSaveAllAlert] = useState(false);
  const { userAccess } = useUserAccess();
  const saveAll = () => {
    setSaveSpecial(true);
  };

  useEffect(() => {
    if (yearTab || year)
      getEquityInvestmentList({
        businessId: businessId,
        setObjects: setSupplies,
      });
  }, [yearTab, year, businessId]);

  return (
    <ApiVarEquityInvestmentContext.Provider value={apiVariable}>
      {supplies.map((supply, i) => {
        return (
          <Link
            className="nav-link"
            to={`/company/equity/${supply.id}?year=` + year}
          >
            <NonCompanyComponent
              index={i}
              name={supply.investee_name}
              address_line_1={"" + supply.invesment_type}
            />
          </Link>
        );
      })}

      {userAccess === "write" && (
        <Link className="nav-link" to={"/company/add-equity?year=" + year}>
          <AddEquity />
        </Link>
      )}
      <AlertV2
        open={saveAllAlert}
        title={"Save All Equity ?"}
        accept={() => {
          saveAll();

          setSaveAllAlert(false);
        }}
        decline={() => setSaveAllAlert(false)}
      />
    </ApiVarEquityInvestmentContext.Provider>
  );
};

export default EquityInvestments;
